import Vue from "vue";
import Router from "vue-router";
import SignIn from "./components/auth/SignIn";
import SignUp from "./components/auth/SignUp";
import Home from "./components/Home";
import Game from "./components/Game";
import GamePreferences from "./components/GamePreferences";
import GameGraveyard from "./components/GameGraveyard";
import GameDiscarded from "./components/GameDiscarded";
import GameJoin from "./components/GameJoin";
import ChangeLog from "./components/ChangeLog";
import PickInvestigator from "./components/PickInvestigator";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
      meta: {
        title: 'Games'
      }
    },
    {
      path: "/signin",
      name: "signin",
      component: SignIn,
      meta: {
        title: 'Sign In'
      }
    },
    {
      path: "/signup",
      name: "signup",
      component: SignUp,
      meta: {
        title: 'Sign Up'
      }
    },
    {
      path: "/change_log",
      name: "change-log",
      component: ChangeLog,
      meta: {
        title: 'Change Log'
      }
    },
    {
      path: "/game/:gameId/:tab?",
      name: "game",
      component: Game,
      meta: {
        title: 'Game'
      }
    },
    {
      path: "/game/:gameId/join/:inviteCode",
      name: "game-join",
      component: GameJoin
    },
    {
      path: "/game_preferences/:gameId/:investigatorId?",
      name: "game-preferences",
      component: GamePreferences,
      meta: {
        title: 'Game Preferences'
      }
    },
    {
      path: "/game_graveyard/:gameId",
      name: "game-graveyard",
      component: GameGraveyard,
      meta: {
        title: 'Game Graveyard'
      }
    },
    {
      path: "/game_discarded/:gameId",
      name: "game-discarded",
      component: GameDiscarded,
      meta: {
        title: 'Game Discarded'
      }
    },
    {
      path: "/pick_investigator",
      name: "pick-investigator",
      component: PickInvestigator,
      meta: {
        title: 'Pick Investigator'
      }
    },
    // Leave this route at the end of the file. That way, it works as a catch-all for all the faulty routes
    // the user might type in the address field regarding our website.
    {
      path: "*",
      redirect: "/"
    }
  ]
});
